import {useEffect} from 'react';

import {PolymerLayout} from 'constants/MapsConstants';

interface UseRedrawParams {
  redraw: (newBoxHeight?: number | ((layout: PolymerLayout) => number)) => void;
  shouldRedraw: () => boolean;
  newBoxHeight: number | ((layout: PolymerLayout) => number);
}

export function useRedraw(useRedrawParams: UseRedrawParams): void {
  const {redraw, shouldRedraw, newBoxHeight} = useRedrawParams;

  useEffect(() => {
    if (shouldRedraw()) {
      redraw(newBoxHeight);
    } else {
      redraw(0);
    }
  }, [redraw, shouldRedraw, newBoxHeight]);
}
